import { useId } from "react";
import { usePrevious } from "../../hooks";
export const useMasonicRerenderKey = items => {
  const id = useId();
  const previousItemsLength = usePrevious(items.length) ?? -1;
  const key = items.length < previousItemsLength ? id : undefined;
  const previousKey = usePrevious(key);
  return key ?? previousKey;
};